// src/components/dasboard/PrivateRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../../firebase/AuthContext";

export default function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/auth" />;
}
